export enum Header {
  MULTI_CDN = 'x-cdn',
}
